import {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import Hero from '../../components/hero'
import About from '../../components/about'
import Features from '../../components/Features'
import CtaSection from '../../components/cta'
import TeamSection from '../../components/team'
import Footer from '../../components/footer'

import Scrollbar from '../../components/scrollbar'
import CulturalHighlightsSection from '../../components/event';
import GallerySection from '../../components/Gallery';


const HomePage =() => {
    return(
        <Fragment>
            <Navbar/>
            <Hero/>
            <About/>
            <TeamSection/>
            <CulturalHighlightsSection />
            <Features/>
            <GallerySection/>
            {/* <Causes/> */}
            <CtaSection/>
            {/* <Testimonial/> */}
            {/* <Partner/> */}
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default HomePage;